import React from 'react';
import { Box, type BoxProps } from '@mui/material';
import { BRAND_LOGO_SRC, BRAND_NAME_LINE_1, BRAND_NAME_LINE_2 } from '../constants/brand';

export interface BrandLogoMarkProps extends BoxProps {
  /** Pixel width; height scales to preserve aspect ratio. */
  width?: number;
}

/**
 * Sustainow Carbon Intelligence logo for auth and marketing surfaces.
 */
const BrandLogoMark: React.FC<BrandLogoMarkProps> = ({
  width = 260,
  sx,
  ...rest
}) => (
  <Box
    component="img"
    src={BRAND_LOGO_SRC}
    alt={`${BRAND_NAME_LINE_1} ${BRAND_NAME_LINE_2}`}
    width={width}
    height="auto"
    sx={{ maxWidth: '100%', display: 'block', mx: 'auto', ...sx }}
    {...rest}
  />
);

export default BrandLogoMark;
